import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "./ui/alert-dialog";

export const DeleteTournament = ({ onConfirm }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="h-8 px-3 rounded-full border border-red-500/40 text-red-400 hover:bg-red-500/10 flex items-center gap-1.5 text-xs transition-colors" data-testid="delete-tournament-button">
        <Trash2 size={14} /> <span className="hidden sm:inline">Elimina torneo</span>
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-[#121824] border-[#26334D]">
      <AlertDialogHeader>
        <AlertDialogTitle>Eliminare il torneo?</AlertDialogTitle>
        <AlertDialogDescription>Il torneo, la classifica e tutti i pronostici verranno cancellati per tutti i giocatori. L'azione è irreversibile.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="delete-cancel">Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-500 hover:bg-red-600" data-testid="delete-confirm">Elimina</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
